import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousand'
})
export class ThousandPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let numberOnly = value.toString().replace(/[^0-9.]/g, '');
    return new Intl.NumberFormat('en-EN', {style: 'decimal'}).format(numberOnly);
  }

}



// WEBPACK FOOTER //
// ./src/app/pipe/thousand.pipe.ts